"use strict";
(function (global) {

  /**
   * Установить пользовательские статусы для всех объектов, расположенных в папке.
   *
   * @function WebAccess.services.folder.setStatusForAllObjects
   * @param {integer} ИД папки
   * @param {string} Наименование пользовательского статуса
   * @return {Deferred} Специальный deferred-объект.
   * @example
   *
   * //Установить на всех объектах в папке с ИД=1232143 пользовательский статус «Зеленый».
   * WA.services.folder.setStatusForAllObjects( 1232143, "Green");
   */
  global.folder.setStatusForAllObjects = function (folderId, statusName) {
    return global.call("/Folder.asmx/SetStatusForAllObjects", {
      'FolderID': folderId,
      'StatusName': statusName
    }, false, false);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess.services);